/**
 * IconButton.js
 * Icon Button with tooltip
 *
 * @class   IconButton
 * @author  Randy Lebeau
 *
 */

import React from 'react';
import ClassNames from 'classnames';
import EnhancedButton from 'components/buttons/enhanced-button/EnhancedButton';
import FontIcon from 'components/font-icon/FontIcon';
import Tooltip from 'components/tooltip/Tooltip';

export default React.createClass({

    propTypes: {
        className: React.PropTypes.string,
        /**
         * Removes padding and margin from icon button
         */
        compact: React.PropTypes.bool,
        disabled: React.PropTypes.bool,
        icon: React.PropTypes.string,
        onBlur: React.PropTypes.func,
        onFocus: React.PropTypes.func,
        tooltip: React.PropTypes.string,
        touch: React.PropTypes.bool,
        active: React.PropTypes.bool,
        tooltipPosition: React.PropTypes.oneOf(['top','bototm','left','right'])
    },

    getInitialState() {
        return {
            tooltipShown: false
        };
    },

    componentDidMount() {
        if (this.props.tooltip) {
            this._positionTooltip();
        }
        if (process.NODE_ENV !== 'production') {
            if (this.props.icon && this.props.children) {
                var warning = 'You have set both an icon and a child icon. ' +
                    'It is recommended you use only one method when adding ' +
                    'icons to IconButtons.';
                console.warn(warning);
            }
        }
    },

    render() {

        let {
            tooltip,
            touch
        } = this.props;

        let classes = ClassNames(
            this.props.className,
            'lui-icon-button',
            {
                'lui-icon-button-compact': this.props.compact,
                'lui-is-active' : this.props.active
            });
        let fonticon;

        if (this.props.tooltip) {
            tooltip = (
                <Tooltip
                    ref="tooltip"
                    className="lui-icon-button-tooltip"
                    label={tooltip}
                    show={this.state.tooltipShown}
                    touch={touch}
                    position={this.props.tooltipPosition}
                    compact={this.props.compact} />
            );
        }

        if (this.props.icon) {
            fonticon = (
                <FontIcon icon={this.props.icon} />
            );
        }

        return (
            <EnhancedButton
                {...this.props}
                ref="button"
                centerRipple={true}
                className={classes}
                onBlur={this._handleBlur}
                onFocus={this._handleFocus}
                onMouseOut={this._handleMouseOut}
                onMouseOver={this._handleMouseOver} >

                    {tooltip}
                    {fonticon}
                    {this.props.children}

            </EnhancedButton>
        );
    },

    _positionTooltip() {
        let tooltip = React.findDOMNode(this.refs.tooltip),
            tooltipWidth = tooltip.offsetWidth,
            button = React.findDOMNode(this.refs.button),
            buttonWidth = button.offsetWidth + 3.5;


        tooltip.style.left = (tooltipWidth - buttonWidth) / 2 * -1 + 'px';
    },

    _showTooltip() {
        if (!this.props.disabled) this.setState({
            tooltipShown: true
        });
    },

    _hideTooltip() {
        this.setState({
            tooltipShown: false
        });
    },

    _handleBlur(e) {
        this._hideTooltip();
        if (this.props.onBlur) this.props.onBlur(e);
    },

    _handleFocus(e) {
        this._showTooltip();
        if (this.props.onFocus) this.props.onFocus(e);
    },

    _handleMouseOut(e) {
        if (!this.refs.button.isKeyboardFocused()) this._hideTooltip();
        if (this.props.onMouseOut) this.props.onMouseOut(e);
    },

    _handleMouseOver(e) {
        this._showTooltip();
        if (this.props.onMouseOver) this.props.onMouseOver(e);
    }

});



/** WEBPACK FOOTER **
 ** ./src/components/buttons/icon-button/IconButton.js
 **/